var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between items-end",class:_vm.wrapperClass},[_c('div',[_c('h2',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"text-base-content/70 mt-2"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }